export const ONE_INCH_POLYGON_LINK =
  'https://app.1inch.io/#/137/swap/USDC/MATIC'
